import { render, staticRenderFns } from "./RegistrationCard.vue?vue&type=template&id=b3f62984&scoped=true&"
import script from "./RegistrationCard.vue?vue&type=script&lang=js&"
export * from "./RegistrationCard.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationCard.vue?vue&type=style&index=0&id=b3f62984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f62984",
  null
  
)

export default component.exports